import React from "react";

import { IBreadcrumb, TeaserHeadingType } from "types";
import { Breadcrumbs } from "components";
import { getTeaserTitle } from "utils";
import { Label } from "components/label/Label";

import { TeaserProps } from "../default-teaser/DefaultTeaser";
import classNames from "classnames";

export interface HorizontalTeaserProps extends TeaserProps {
  meta?: string;
  breadcrumbs: IBreadcrumb[];
  theme?: "light" | "dark";
  bundle: string | undefined;
}

export const HorizontalTeaser: React.FC<HorizontalTeaserProps> = ({
  url,
  title,
  intro,
  meta,
  image,
  breadcrumbs,
  headingType = TeaserHeadingType.h2,
  mediaLabel,
  teaserType,
  theme,
}) => (
  <a
    href={url}
    className={classNames("horizontal-teaser", [
      teaserType && `is-${teaserType}`,
      theme && `is-${theme}`,
    ])}
  >
    <div className="horizontal-teaser__inner">
      <div className="horizontal-teaser__breadcrumbs">
        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>

      {getTeaserTitle(title, headingType, ["horizontal-teaser__title"])}

      {intro && (
        <div className="horizontal-teaser__text">
          <p dangerouslySetInnerHTML={{ __html: intro }} />
        </div>
      )}
      {meta && <div className="horizontal-teaser__meta">{meta}</div>}
    </div>
    {image && (
      <div className="horizontal-teaser__media">
        <img src={image} alt={title} className="horizontal-teaser__image" />
        {mediaLabel && (
          <span className="horizontal-teaser__media-label">
            <Label {...mediaLabel} />
          </span>
        )}
      </div>
    )}
  </a>
);
